__turbopack_context__.v({
  "root": "U1VIOW_root",
});
